module.exports = __webpack_public_path__ + "img/SS BG-02.b0ab4882.png";